module.exports = __webpack_public_path__ + "rosacea_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_4_before_tn.jpg
// module id = 1452
// module chunks = 0